<template>
  <div style="line-height:2;padding-top:10px;margin-top:10px;border-top:1px solid #eee;">
    <div>跟进信息</div>
    <div style="max-height: 200px;overflow-y: auto;">
      <div v-for="commit in commits" :key="commit._id" style="margin-bottom:10px;font-size:12px;">
        <div style="color:#666">
          <div style="font-weight:bold;font-size:12px;color:#000">{{commit.account}}：</div>
          <div style="padding-left:10px">
            <pre style="white-space:pre-wrap;margin:0;line-height:1.5;">{{commit.content}}</pre>
            <div>
              <span style="color:#d7d7d7">{{commit.createdAt}}</span>
              <span class="a-link" @click="reply(commit._id, commit.account)" style="margin-left:5px;color:#85AFDA">回复</span>
              <span v-if="account == commit.account" class="a-link" @click="del(commit._id)" style="color:#F56C6C;margin-left:5px">删除</span>
            </div>
          </div>
        </div>
        <div v-if="commit.children && commit.children.length > 0" style="margin-left:30px;padding-left:5px;border-left:2px solid #eee">
          <div v-for="child in commit.children" :key="child._id" style="color:#999;">
            <div>{{child.account}}回复{{child.replyAccount}}：</div>
            <div style="padding-left:10px">
              <pre style="white-space:pre-wrap;margin:0;line-height:1.5;">{{child.content}}</pre>
              <div>
                <span style="color:#d7d7d7">{{child.createdAt}}</span>
                <span class="a-link" @click="reply(commit._id, child.account)" style="margin-left:5px;color:#85AFDA">回复</span>
                <span v-if="account == child.account" class="a-link" @click="del(child._id)" style="color:#F56C6C;margin-left:5px">删除</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display:flex;position:relative;padding-top:10px;">
      <el-input ref="textarea" type="textarea" v-model="text" rows="2" @keydown.native="handleKeyDown" placeholder="输入评论内容，点击发送按钮或按下回车键发送" class="commit-textarea"></el-input>
      <el-button type="primary" size="mini" @click="addCommit" style="margin-left:10px;background:#85AFDA;border-color:#85AFDA">发 送</el-button>
      <div style="position:absolute;left:5px;color:#aaa">{{ replyAccount?`回复${replyAccount}：`:'发表评论：' }}</div>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  props: {
    bulletinId: String,
  },
  watch: {
    bulletinId() {
      this.listCommit()
    }
  },
  mounted() {
    this.listCommit()
  },
  data() {
    return {
      commits: [],
      text: '',
      replyAccount: '',
      replyCommitId: '',
      lastText: '',
    }
  },
  computed: {
    account() {
      return app.user.account
    }
  },
  methods: {
    async listCommit() {
      this.init()
      if (this.bulletinId) {
        const res = await app.service('misc').listBulletinCommits({bulletinId: this.bulletinId})
        if (res.status == 'success') {
          const parents = res.data.filter(dt => !dt.replyCommitId)
          this.commits = parents.map(p => {
            p.children = res.data.filter(dt => dt.replyCommitId == p._id).map(dt=>{
              dt.createdAt = dateFormat(dt.createdAt, 'yyyy-mm-dd HH:MM:ss')
              return dt
            })
            p.createdAt = dateFormat(p.createdAt, 'yyyy-mm-dd HH:MM:ss')
            return p
          })
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    async addCommit() {
      this.text = this.text.trim()
      if (!this.text) return this.$message('请输入评论内容')
      const param = {
        bulletinId: this.bulletinId,
        account: app.user.account,
        content: this.text,
      }
      if (this.replyAccount) param.replyAccount = this.replyAccount
      if (this.replyCommitId) param.replyCommitId = this.replyCommitId
      const res = await app.service('misc').addBulletinCommit(param)
      if (res.status == 'success') {
        this.$message.success('发送成功')
        this.listCommit()
      } else {
        this.$message.error(res.msg)
      }
    },
    async del(_id) {
      const res = await app.service('misc').deleteBulletinCommits({_id})
      if (res.status == 'success') {
        this.$message.success('删除成功')
        this.listCommit()
      } else {
        this.$message.error(res.msg)
      }
    },
    init() {
      this.text = ''
      this.replyAccount = ''
      this.replyCommitId = ''
    },
    reply(replyCommitId, replyAccount) {
      this.replyCommitId = replyCommitId
      this.replyAccount = replyAccount
      console.log(document.querySelector('.commit-textarea .el-textarea__inner'))
      document.querySelector('.commit-textarea .el-textarea__inner').focus()
    },
    handleKeyDown(e) {
      // console.log(e.keyCode, this.text, this.lastText, e.ctrlKey)
      if (e.keyCode == 8 && !this.text && !this.lastText) {
        this.replyCommitId = ''
        this.replyAccount = ''
      } else if (e.keyCode == 13) {
        if (e.ctrlKey) {
          this.text += '\n'
        } else {
          e.preventDefault()
          this.addCommit()
        }
      }
      this.lastText = this.text
    }
  }
}
</script>
<style>
.commit-textarea .el-textarea__inner {
  padding-top: 25px;
  font-size: 12px;
}
/* .commit-textarea .el-textarea__inner::placeholder {
  font-size: 12px;
} */
</style>
